module.exports = __webpack_public_path__ + "img/sdg_en_(11).9f964b40.png";